import {put, takeEvery, select} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import putStoreAppearanceApi from 'helpers/services/api/storeAppearanceApi';
import {
  SAVE_DATA,
  SAVE_DATA_SUCCESS,
  SET_LOADING,
  GET_EMAIL_MARKETING_TRIAL_DATE,
  GET_EMAIL_MARKETING_TRIAL_DATE_SUCCESS
} from 'store/storeAppearance/action';
import {UPDATE_STORE_APPEARANCE} from 'store/global/user/action';
import {getEmailMarketingTrialDateApi} from 'helpers/services/api/emailMarketing';

function* putStoreAppearance({payload: {locationId, data}}) {
  try {
    yield put(SET_LOADING(true));
    const {status} = yield putStoreAppearanceApi(locationId, data);
    if (status === 200) {
      toast.success('Changes were saved successfully');
      yield put(UPDATE_STORE_APPEARANCE(data));
      yield put(SAVE_DATA_SUCCESS());
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  } finally {
    yield put(SET_LOADING(false));
  }
}

function* checkEmailMarketingTrialDate() {
  const locationId = yield select((state) => state.user.locationId);
  const {activeLocation} = yield select((state) => state.user);
  if (activeLocation?.AllowedServiceFeatures?.includes('email_marketing_pcs')) {
    try {
      const emailMarketingTrialResponse = yield getEmailMarketingTrialDateApi(
        locationId
      );
      if (emailMarketingTrialResponse?.data) {
        yield put(
          GET_EMAIL_MARKETING_TRIAL_DATE_SUCCESS(
            emailMarketingTrialResponse.data
          )
        );
      }
    } catch (error) {
      yield put(GET_EMAIL_MARKETING_TRIAL_DATE_SUCCESS({startDate: null}));
      console.log('SAGA ERROR', error);
    }
  } else {
    yield put(GET_EMAIL_MARKETING_TRIAL_DATE_SUCCESS({startDate: null}));
  }
}

function* storeAppearanceSaga() {
  yield takeEvery(SAVE_DATA, putStoreAppearance);
  yield takeEvery(GET_EMAIL_MARKETING_TRIAL_DATE, checkEmailMarketingTrialDate);
}

export default storeAppearanceSaga;
